import type { UserGroupConvertToOrganizationApiData, UserGroupConvertToOrganizationApiResponses } from '@navio/nsdk';
import { apiUrl, responseEndpoint } from '../defineResource';

export const convertToOrganizationUrls = {
  postUserGroupConvertToOrganization: responseEndpoint<
    UserGroupConvertToOrganizationApiData,
    UserGroupConvertToOrganizationApiResponses
  >({
    getUrl: ({ userGroupId }) => apiUrl(`user-groups/${userGroupId}/convert-to-organization/`),
    getBody: ({ userGroupId: _, ...body }) => body
  })
};
